import type { ToastMessageOptions } from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { useLogger } from ".";
const { error } = useLogger("TOASTER");

// THIS JUST ALIASES THE ToastMessageOptions FROM PRIMEVUE
export interface ToasterSettings extends ToastMessageOptions {}

export function useGenericNotification() {
  const toaster = useToast();

  const fireToast = (settings: ToasterSettings): void => {
    if (toaster) {
      toaster.add({
        severity: settings.severity || "warn",
        summary: settings.summary || "Warning",
        detail: settings.detail,
        life: settings.life,
        closable: settings.closable ?? true,
        group: settings.group
      });
    } else {
      error("Toaster not initialized");
    }
  };

  return {
    fireToast
  };
}
